<template>
  <v-card color="white" :loading="loading" :disabled="loading">
    <v-card-title class="justify-center" style="background-color: #5E676E;">
      <div class="white--text">
        <div class="text-center">全院預約限制</div>
      </div>
    </v-card-title>

    <v-card-text class="py-8">
      <v-checkbox
        :input-value="clinicWideStatus"
        true-value="1"
        false-value="0"
        hide-details
        dense
        class="ma-0"
        label="限制患者在本診所僅能送出一筆線上預約"
        @change="handleChange"
      />
      <div class="mt-1 ml-8 text-caption grey--text text--darken-1">
        開啟後，患者在本診所所有醫師中僅能有一筆未處理的線上預約
      </div>
    </v-card-text>
  </v-card>
</template>

<script>
import { mapGetters } from "vuex";
import { getFreeTimeAPI, updateClinicWideAppointmentSettingAPI } from "@/api";

export default {
  name: "ClinicWideAppointmentSetting",

  data() {
    return {
      loading: false,
      clinicWideStatus: '0',
    }
  },

  computed: {
    ...mapGetters(['axiosParamData']),
  },

  mounted() {
    this.fetchStatus()
  },

  methods: {
    async fetchStatus() {
      this.loading = true
      try {
        const res = await getFreeTimeAPI(this.axiosParamData)
        if (res.data && res.data.length > 0) {
          this.clinicWideStatus = res.data[0].clinic_wide_unprocessed_appointment_status || '0'
        }
      } catch (e) {
        console.error(e)
      } finally {
        this.loading = false
        this.$emit('loaded')
      }
    },

    handleChange(value) {
      this.save(value)
    },

    async save(value) {
      this.loading = true
      try {
        await updateClinicWideAppointmentSettingAPI({
          ...this.axiosParamData,
          clinic_wide_unprocessed_appointment_status: value,
        })
        this.clinicWideStatus = value
      } catch (e) {
        console.error(e)
        this.$notify.error('儲存失敗')
      } finally {
        this.loading = false
      }
    },
  },
}
</script>
